(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var _ = require('lodash')

module.exports = function () {
  return function (type, id) {
    var $promoter = this.$('.js-promoter')
      , promoters = $promoter.val() || []
      , selectize = $promoter[0].selectize
      , options = selectize.options
      , $contact = this.$('.js-contact')
      , contactSelectize = $contact[0].selectize
      , _contacts

    if (type === 'add') promoters.push(id)

    _contacts = _(options)
      .pick(promoters)
      .values()
      .pluck('_contacts')
      .flatten()
      .filter(function (contact) { return !contact.blacklist })
      .value()

    if (type === 'delete') {
      _(contactSelectize.options)
        .values()
        .pluck('_id')
        .difference(_.pluck(_contacts, '_id'))
        .map(contactSelectize.removeOption, contactSelectize)
    }
    contactSelectize.addOption(_contacts)
    this.model.set('__contacts', _contacts)
  }
}


}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/festival/lib/promoter-change-delegate.js","/components/admin/festival/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvYWRtaW4vZmVzdGl2YWwvbGliL3Byb21vdGVyLWNoYW5nZS1kZWxlZ2F0ZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsidmFyIF8gPSByZXF1aXJlKCdsb2Rhc2gnKVxuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uICgpIHtcbiAgcmV0dXJuIGZ1bmN0aW9uICh0eXBlLCBpZCkge1xuICAgIHZhciAkcHJvbW90ZXIgPSB0aGlzLiQoJy5qcy1wcm9tb3RlcicpXG4gICAgICAsIHByb21vdGVycyA9ICRwcm9tb3Rlci52YWwoKSB8fCBbXVxuICAgICAgLCBzZWxlY3RpemUgPSAkcHJvbW90ZXJbMF0uc2VsZWN0aXplXG4gICAgICAsIG9wdGlvbnMgPSBzZWxlY3RpemUub3B0aW9uc1xuICAgICAgLCAkY29udGFjdCA9IHRoaXMuJCgnLmpzLWNvbnRhY3QnKVxuICAgICAgLCBjb250YWN0U2VsZWN0aXplID0gJGNvbnRhY3RbMF0uc2VsZWN0aXplXG4gICAgICAsIF9jb250YWN0c1xuXG4gICAgaWYgKHR5cGUgPT09ICdhZGQnKSBwcm9tb3RlcnMucHVzaChpZClcblxuICAgIF9jb250YWN0cyA9IF8ob3B0aW9ucylcbiAgICAgIC5waWNrKHByb21vdGVycylcbiAgICAgIC52YWx1ZXMoKVxuICAgICAgLnBsdWNrKCdfY29udGFjdHMnKVxuICAgICAgLmZsYXR0ZW4oKVxuICAgICAgLmZpbHRlcihmdW5jdGlvbiAoY29udGFjdCkgeyByZXR1cm4gIWNvbnRhY3QuYmxhY2tsaXN0IH0pXG4gICAgICAudmFsdWUoKVxuXG4gICAgaWYgKHR5cGUgPT09ICdkZWxldGUnKSB7XG4gICAgICBfKGNvbnRhY3RTZWxlY3RpemUub3B0aW9ucylcbiAgICAgICAgLnZhbHVlcygpXG4gICAgICAgIC5wbHVjaygnX2lkJylcbiAgICAgICAgLmRpZmZlcmVuY2UoXy5wbHVjayhfY29udGFjdHMsICdfaWQnKSlcbiAgICAgICAgLm1hcChjb250YWN0U2VsZWN0aXplLnJlbW92ZU9wdGlvbiwgY29udGFjdFNlbGVjdGl6ZSlcbiAgICB9XG4gICAgY29udGFjdFNlbGVjdGl6ZS5hZGRPcHRpb24oX2NvbnRhY3RzKVxuICAgIHRoaXMubW9kZWwuc2V0KCdfX2NvbnRhY3RzJywgX2NvbnRhY3RzKVxuICB9XG59XG5cbiJdfQ==